import { BD_BRAND_COLOR_HEX_OPTIONS } from './color.const';

/**
 * ────────────────────────────────────────────────────────────────────────────
 * The automatic series colours for chart parts
 * ────────────────────────────────────────────────────────────────────────────
 *
 * One rule for both cubes (BDA-5849). It started as the Klinik-Cube's private
 * palette in `clinics-cube-feature/tile-result/chart-palette.ts`, while the
 * origin Cube had none and seeded {@link BD_COLOR_HEX_DEFAULT_OPTIONS}`[0]` —
 * the SAME orange — into every new part, so a Cube chart drew every series in
 * one colour until someone opened "Darstellung" for each of them. The rule
 * lives here, beside the brand and picker constants, and neither cube owns it.
 *
 * The series colours ARE the BinDoc brand colours
 * ({@link BD_BRAND_COLOR_HEX_OPTIONS}), in their order (BDA-6341): a fresh
 * chart should already look like BinDoc, not only offer the brand swatches in
 * the picker. There is deliberately no second, chart-only palette — the brand
 * list is the single source.
 *
 * Plain strings on purpose: the colours are consumed by chart.js, which paints
 * on a canvas and cannot resolve a CSS custom property, and by stored
 * documents, which persist plain hex.
 */

/**
 * Everything past the last brand colour shares one neutral.
 *
 * Cycling the brand colours instead would give series 5 the colour of series 1,
 * and a legend that repeats a colour for two different series is worse than
 * one that stops colour-coding. This is `--p-surface-300` (gray.300) as a
 * literal, for the canvas reason above.
 */
export const BD_CHART_SERIES_TAIL_COLOR = '#d1d5db';

/**
 * The colour of series `index`: the brand colours in order, then the neutral
 * tail.
 *
 * `index` is the part's ordinal among a tile's DATASET parts — annotations draw
 * a line at a value and take no palette slot, so counting them would shift
 * every colour behind the first annotation.
 */
export function bdChartSeriesColor(index: number): string {
  return index < BD_BRAND_COLOR_HEX_OPTIONS.length
    ? BD_BRAND_COLOR_HEX_OPTIONS[index]
    : BD_CHART_SERIES_TAIL_COLOR;
}
